import ReactGA from 'react-ga';

ReactGA.initialize('269726528');

export default ReactGA;

